import { render, staticRenderFns } from "./TestPage.vue?vue&type=template&id=55e177ce&scoped=true"
import script from "./TestPage.vue?vue&type=script&lang=js"
export * from "./TestPage.vue?vue&type=script&lang=js"
import style0 from "./TestPage.vue?vue&type=style&index=0&id=55e177ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e177ce",
  null
  
)

export default component.exports